import {
  Wifi,
  Car,
  UtensilsCrossed,
  Wine,
  BellRing,
  Snowflake,
  Droplets,
  Shirt,
  Clock,
} from "lucide-react";
import { siteConfig } from "../config/siteConfig";

const ICONS = {
  Wifi,
  Car,
  UtensilsCrossed,
  Wine,
  BellRing,
  Snowflake,
  Droplets,
  Shirt,
  Clock,
};

export default function Facilities() {
  const list = siteConfig.facilities.filter((f) => f.show);

  return (
    <section
      id="facilities"
      data-testid="facilities-section"
      className="section bg-[#FAF9F6]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 reveal">
          <p className="font-overline mb-4">Comforts</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A362D] mb-4">
            Hotel Facilities
          </h2>
          <div className="gold-divider"></div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 sm:gap-5">
          {list.map((f) => {
            const Icon = ICONS[f.icon] || BellRing;
            return (
              <div
                key={f.id}
                data-testid={`facility-${f.id}`}
                className="bg-[#FAF9F6] rounded-3xl p-8 sm:p-10 flex flex-col items-center text-center gap-4 hover:bg-[#1A362D] hover:text-[#FAF9F6] hover:-translate-y-1 transition-all duration-500 group cursor-default"
              >
                <div className="w-14 h-14 rounded-full border border-[#C5A059] flex items-center justify-center group-hover:bg-[#C5A059] transition-colors duration-500">
                  <Icon
                    className="w-6 h-6 text-[#C5A059] group-hover:text-[#1A362D] transition-colors"
                    strokeWidth={1.5}
                  />
                </div>
                <p className="font-display text-lg group-hover:text-[#FAF9F6] transition-colors">
                  {f.label}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
